import { withStyles } from "@material-ui/core/styles";
import FilterSearch from "./FilterSearch";
import styles from "./styles";

export default withStyles(styles)(FilterSearch);
